import React from 'react';
import { Select } from 'antd';
import { useNavigate } from 'react-router-dom';

const ProjectSelect = ({ tenants, tenantId, location }) => {
  const navigate = useNavigate();

  // заменяет тенант на указанный
  const replaceLocationTenant = (tenant) => {
    const locationSplit = location.split('/');
    locationSplit.splice(1, 1, tenant);

    return locationSplit.join('/');
  };

  // редирект на выбранный тенант
  const onChange = (tenant) => {
    navigate(replaceLocationTenant(tenant));
  };

  return (
    <Select
      showSearch
      placeholder="Select a project"
      optionFilterProp="children"
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={{ width: 'auto', minWidth: '190px' }}
      dropdownMatchSelectWidth={false}
      dropdownStyle={{ width: 'auto' }}
      disabled={tenants.length === 1 || tenants.length === 0}
      value={tenantId === '' ? undefined : tenantId}
      // т.к. начальный стейт имеет пустую строку для тенанта => не срабатывает плейсхолдер

      onChange={onChange}
    >
      {[...(tenants || [])]
        .sort((a, b) => a.localeCompare(b))
        .map((tenant) => (
          <Select.Option key={tenant} value={tenant}>
            {tenant}
          </Select.Option>
        ))}
    </Select>
  );
};

export default ProjectSelect;
